import { apiClient } from './apiClient';

export interface EngagementSearchResponse {
  accounts: AccountSearchResult[];
  projects: ProjectSearchResult[];
  projectTeams: ProjectTeamSearchResult[];
  employees: EmployeeSearchResult[];
  lastSyncedAt?: string;
}

export interface AccountSearchResult {
  accountId: number;
  accountName: string;
  engagementTypes: string[];
}

export interface ProjectSearchResult {
  projectId: number;
  accountId: number;
  accountName: string;
  projectName: string;
}

export interface ProjectTeamSearchResult {
  projectTeamId: number;
  teamName: string;
  accountId: number;
  accountName: string;
  projectName: string;
  memberCount: number;
}

export interface EmployeeSearchResult {
  employeeId: number;
  employeeName: string;
  teamRole: string;
  projectTeamId: number;
  accountId: number;
  accountName: string;
  projectName: string;
  teamName: string;
}

export interface AssignmentSelection {
  scope: 'account' | 'project' | 'team' | 'employee';
  id: number;
  name: string;
  accountName?: string;
  projectName?: string;
  teamName?: string;
  teamRole?: string;
}

export interface MembersPreview {
  members: ResolvedMember[];
  totalMembers: number;
  missingEmails: number;
  scope: string;
  scopeId: number;
  scopeName: string;
}

export interface ResolvedMember {
  employeeId: number;
  employeeName: string;
  email: string;
  teamRole?: string;
  projectName?: string;
  teamName?: string;
}

export const deliverySearchService = {
  async search(query: string): Promise<EngagementSearchResponse> {
    const response = await apiClient.get(`/api/engagement/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  async resolveEmails(assignments: { scope: string; id: number }[]): Promise<ResolvedMember[]> {
    const response = await apiClient.post('/api/engagement/resolve-emails', { assignments });
    return response.data;
  },

  async previewMembers(scope: string, id: number): Promise<MembersPreview> {
    const response = await apiClient.get(`/api/engagement/members?scope=${scope}&id=${id}`);
    return response.data;
  },
};
